const locale = {
	// #region Tickets fields
	DETAILS_TICKETS_FIELD_TITLE: 'Titolo',
	DETAILS_TICKETS_FIELD_STATUS: 'Stato Ticket',
	DETAILS_TICKETS_FIELD_TYPE: 'Tipo Ticket',
	DETAILS_TICKETS_FIELD_COMPANY: 'Cliente',
	DETAILS_TICKETS_FIELD_PERSON: 'Referente esterno',
	DETAILS_TICKETS_FIELD_ASSIGNED_USER: 'Utente assegnato interno',
	DETAILS_TICKETS_FIELD_ASSIGNED_USER_2: 'Utente assegnato esterno',
	DETAILS_TICKETS_FIELD_DATE_FROM: 'Data inizio',
	DETAILS_TICKETS_FIELD_DATE_TO: 'Data fine',
	DETAILS_TICKETS_FIELD_INTERNALNUMBER: 'Numero Interno',
	DETAILS_TICKETS_FIELD_TAGS: 'Tag',
	DETAILS_TICKETS_FIELD_WARNING: 'Warning',
	DETAILS_TICKETS_FIELD_BLOCKED: 'Bloccato'
	// DETAILS_TICKETS_FIELD_HOURS: 'Ore preposte',
	// #endregion
};

export default locale;
